import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'repChat'
})
export class FiltroRepChatPipe implements PipeTransform {

  transform(arreglo: any[], texto: string): any[] {
    // console.log(texto);
    if(!texto){
      return arreglo;
    }

    if( arreglo.length === 0 ) {
      return arreglo;
    }
    texto = texto.toLocaleLowerCase();

    return arreglo.filter( item => {
      return item.conversacion.numero.numeroCliente.toLowerCase().includes(texto) || item.nombreCliente.toLowerCase().includes(texto) || item.agente.toLowerCase().includes(texto) 
      || item.statusConver.toLowerCase().includes(texto) || item.conversacion.origen.toLowerCase().includes(texto);
    });
    // return arreglo;
  }

}